import React from 'react'
import { Text } from '../../typography/Text'
import { inputRange } from '../styles/inputRange.css'

interface InputRangeProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export const InputRange: React.FC<InputRangeProps> = ({ label, ...rest }) => {
  return (
    <div className="flex flex-column gap-12 items-center">
      {label && <Text weightClass="font-medium">{label}</Text>}
      <input type="range" {...rest} className={inputRange}></input>
    </div>
  )
}
